<script>
    import { Router } from "@roxi/routify";
    import { routes } from "../.routify/routes";

    import './assets/FenomenSans/FenomenSans.css'
    import './assets/FenomenSans-Bold/FenomenSans.css'
    import './assets/FenomenSans-SemiBold/FenomenSans.css'
    import './assets/FenomenSans-Italic/FenomenSans.css'
    import './assets/FenomenSans-BoldItalic/FenomenSans.css'
    const config = {

        urlTransform: {
            apply: url => `/app${url}`, //external URL
            remove: url => url.replace('/app', ''), //internal URL
        },
        useHash: false
    }
</script>

<Router {routes} {config} />